import * as React from 'react';

function SvgCloseButton(props) {
	return (
		<svg width="1em" height="1em" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g fill="#000" fillRule="evenodd">
				<path d="M2.454.833l21.213 21.213-2.121 2.121L.333 2.954z" />
				<path d="M23.667 2.954L2.454 24.167.333 22.046 21.546.833z" />
			</g>
		</svg>
	);
}

export default SvgCloseButton;
